import {
    GET_PREFERRED_PROVIDER_START,
    GET_PREFERRED_PROVIDER_SUCCESS,
    GET_PREFERRED_PROVIDER_ERROR
} from '../../../constants';

import { change } from 'redux-form';
import showToaster from '../../../helpers/toastrMessgaes/showToaster';
import { getNearestPreferredPartner as query } from "../../../lib/graphql";

export const getNearestPreferredPartner = (variables, isSearch) => {

    try {
        return async (dispatch, getState, { client }) => {

            dispatch({
                type: GET_PREFERRED_PROVIDER_START,
                payload: {
                    loading: true,
                    preferredProviders:[]
                }
            });

            const { data } = await client.query({
                query,
                variables,
                fetchPolicy: 'network-only'
            });

            let isAvailableProvider = data?.getNearestPreferredPartner?.status == 200;
                !isSearch && isAvailableProvider && dispatch(change('ManualBookingForm', 'isPreferredProvider', true));
                dispatch({
                    type: isAvailableProvider ?  GET_PREFERRED_PROVIDER_SUCCESS : GET_PREFERRED_PROVIDER_ERROR,
                    payload: {
                        loading: false,
                        preferredProviders: data?.getNearestPreferredPartner?.results
                    }
                });
    
            !isSearch && !isAvailableProvider && showToaster({ messageId: 'errorMessage', requestContent: data?.getNearestPreferredPartner?.errorMessage , toasterType: 'error' });
            return true;
        }

    } catch (error) {
        showToaster({ messageId: 'catchMessage', requestContent: error, toasterType: 'error' });
        dispatch({
            type: GET_PREFERRED_PROVIDER_ERROR,
            payload: {
                loading: false,
                preferredProviders: []
            }
        });
        return false;
    }
}
